export default class EmeNotSupportedError extends Error {
    constructor(message) {
        super(message);
        this.name = 'EmeNotSupportedError';
    }
}
